import { render } from "./InvestmentsChart.vue?vue&type=template&id=d3f8d51e"
import script from "./InvestmentsChart.vue?vue&type=script&lang=js"
export * from "./InvestmentsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__